<app-main-nav-bar></app-main-nav-bar>
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-body">
        <div class="main" data-request="1335">
          <div class="wrap">
            <div class="offer elem" style="display: block;">
              <div class="row">
                <div class="col col-12">
                  <div class="head">
                    <h3>اطلاعات فردی</h3>
                    <p>لطفا اطلاعات زیر را با دقت پر نمایید</p>
                  </div>
                </div>
              </div>
              <br>
              <app-form [formGroup]="formGroup" [productName]="productName"></app-form>
            </div>
            <br>
            <app-custom-button [Show]="true"
                               [disabled]="!formGroup.valid"
                               [LabelText]="'تایید و ثبت'"
                               (OnClick)="submit()"
                               [backButtonLabel]="'بیمه های من'"
                               [BackButton]="true"
                               [backUrl]="myRequestsUrl">
            </app-custom-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
